// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/inspectionTemplates.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9741 S1: inspection checklists per equipment type / unit.)
//
// Side-effect module: attaches `window.InspectionTemplates`. pretrip.js reads
// it at CALL time (Pitfall #1 — never a cross-`?v=` import).
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var INSPECTION_TEMPLATE_LIMITS = {
    maxTemplates: 25,
    maxItems: 40,
    maxNameLen: 60,
    maxLabelLen: 80,
    maxTypes: 30,
    maxUnits: 200,
    maxIdLen: 40
  };

  var INSPECTION_ASSET_KINDS = ['truck', 'trailer', 'equipment'];

  // TASK-10135 — which inspection an item shows on. 'both' is the default.
  var INSPECTION_ITEM_PHASES = ['both', 'pre', 'post'];

  /** 'pre' | 'post' | 'both' (anything else, including missing, is 'both'). */
  function inspectionItemPhase(phase) {
    return phase === 'pre' || phase === 'post' ? phase : 'both';
  }

  // The base checklists, moved here verbatim from pretrip.js (TASK-9741) so the
  // driver form and the server-printed blank form read ONE list. Full DOT DVIR
  // per FMCSA 396.11/396.13 for truck + trailer.
  var INSPECTION_BASE_ITEMS = {
    truck: [
      { id: 'air_compressor', label: 'Air Compressor', icon: 'warning', group: 'Brakes' },
      { id: 'air_lines', label: 'Air Lines', icon: 'warning', group: 'Brakes' },
      { id: 'brake_accessories', label: 'Brake Accessories', icon: 'warning', group: 'Brakes' },
      { id: 'brakes_parking', label: 'Parking Brake', icon: 'warning', group: 'Brakes' },
      { id: 'brakes_service', label: 'Service Brakes', icon: 'warning', group: 'Brakes' },
      { id: 'headlights', label: 'Head/Stop Lights', icon: 'lightbulb', group: 'Lights' },
      { id: 'tail_lights', label: 'Tail/Dash Lights', icon: 'lightbulb', group: 'Lights' },
      { id: 'turn_signals', label: 'Turn Indicators', icon: 'lightbulb', group: 'Lights' },
      { id: 'clearance_lights', label: 'Clearance/Marker Lights', icon: 'lightbulb', group: 'Lights' },
      { id: 'reflectors', label: 'Reflectors', icon: 'brightness_high', group: 'Lights' },
      { id: 'horn', label: 'Horn', icon: 'volume_up', group: 'Cab' },
      { id: 'mirrors', label: 'Mirrors', icon: 'flip', group: 'Cab' },
      { id: 'windshield', label: 'Windshield', icon: 'window', group: 'Cab' },
      { id: 'wipers', label: 'Wipers/Washers', icon: 'water_drop', group: 'Cab' },
      { id: 'defroster_heater', label: 'Defroster/Heater', icon: 'thermostat', group: 'Cab' },
      { id: 'steering', label: 'Steering Mechanism', icon: 'sports_esports', group: 'Cab' },
      { id: 'gauges', label: 'Gauges/Warning Indicators', icon: 'speed', group: 'Cab' },
      { id: 'seatbelt', label: 'Seat Belt', icon: 'airline_seat_recline_normal', group: 'Cab' },
      { id: 'tires', label: 'Tires', icon: 'tire_repair', group: 'Tires & Wheels' },
      { id: 'wheels_rims', label: 'Wheels/Rims/Lugs', icon: 'donut_large', group: 'Tires & Wheels' },
      { id: 'body', label: 'Body/Frame', icon: 'local_shipping', group: 'Body' },
      { id: 'exhaust', label: 'Exhaust System', icon: 'air', group: 'Body' },
      { id: 'fluid_leaks', label: 'Oil/Fluid Leaks', icon: 'opacity', group: 'Body' },
      { id: 'fuel_system', label: 'Fuel System', icon: 'local_gas_station', group: 'Body' },
      { id: 'suspension', label: 'Suspension', icon: 'swap_vert', group: 'Body' },
      { id: 'emergency_equip', label: 'Emergency Equipment', icon: 'medical_services', group: 'Safety' },
      { id: 'fire_extinguisher', label: 'Fire Extinguisher', icon: 'local_fire_department', group: 'Safety' },
      { id: 'triangles', label: 'Warning Triangles', icon: 'change_history', group: 'Safety' },
      { id: 'flags_flares', label: 'Flags/Flares/Fusees', icon: 'flare', group: 'Safety' },
      { id: 'fifth_wheel', label: 'Fifth Wheel', icon: 'link', group: 'Coupling' },
      { id: 'pintle_hook', label: 'Pintle Hook/Drawbar', icon: 'link', group: 'Coupling' },
      { id: 'other', label: 'Other', icon: 'more_horiz', group: 'Other' }
    ],
    trailer: [
      { id: 'brake_connections', label: 'Brake Connections', icon: 'warning', group: 'Brakes' },
      { id: 'brakes_trailer', label: 'Brakes', icon: 'warning', group: 'Brakes' },
      { id: 'tail_lights', label: 'Tail/Stop Lights', icon: 'lightbulb', group: 'Lights' },
      { id: 'turn_signals', label: 'Turn Indicators', icon: 'lightbulb', group: 'Lights' },
      { id: 'clearance_lights', label: 'Clearance/Marker Lights', icon: 'lightbulb', group: 'Lights' },
      { id: 'reflectors', label: 'Reflectors/Reflective Tape', icon: 'brightness_high', group: 'Lights' },
      { id: 'coupling_devices', label: 'Coupling Devices', icon: 'link', group: 'Coupling' },
      { id: 'king_pin', label: 'King Pin/Upper Plate', icon: 'link', group: 'Coupling' },
      { id: 'safety_chains', label: 'Safety Chains/Cables', icon: 'link', group: 'Coupling' },
      { id: 'tires', label: 'Tires', icon: 'tire_repair', group: 'Tires & Wheels' },
      { id: 'wheels_rims', label: 'Wheels/Rims/Lugs', icon: 'donut_large', group: 'Tires & Wheels' },
      { id: 'frame', label: 'Frame/Body', icon: 'local_shipping', group: 'Body' },
      { id: 'landing_gear', label: 'Landing Gear', icon: 'vertical_align_bottom', group: 'Body' },
      { id: 'doors', label: 'Doors/Hinges/Latches', icon: 'meeting_room', group: 'Body' },
      { id: 'suspension', label: 'Suspension', icon: 'swap_vert', group: 'Body' },
      { id: 'roof', label: 'Roof/Tarp', icon: 'roofing', group: 'Body' },
      { id: 'other', label: 'Other', icon: 'more_horiz', group: 'Other' }
    ],
    equipment: [
      { id: 'general_condition', label: 'General Condition', icon: 'visibility', group: 'Condition' },
      { id: 'structural_integrity', label: 'Structural Integrity', icon: 'foundation', group: 'Condition' },
      { id: 'fluid_leaks', label: 'Fluid Leaks', icon: 'opacity', group: 'Condition' },
      { id: 'hoses_fittings', label: 'Hoses/Fittings', icon: 'plumbing', group: 'Condition' },
      { id: 'lubrication', label: 'Lubrication Points', icon: 'water_drop', group: 'Condition' },
      { id: 'safety_guards', label: 'Safety Guards/Covers', icon: 'security', group: 'Safety' },
      { id: 'electrical', label: 'Electrical/Wiring', icon: 'electrical_services', group: 'Safety' },
      { id: 'emergency_shutoff', label: 'Emergency Shutoff', icon: 'power_settings_new', group: 'Safety' },
      { id: 'controls', label: 'Controls/Switches', icon: 'tune', group: 'Operation' },
      { id: 'pressure_gauges', label: 'Pressure Gauges', icon: 'speed', group: 'Operation' },
      { id: 'operational_test', label: 'Operational Test', icon: 'play_circle', group: 'Operation' },
      { id: 'other', label: 'Other', icon: 'more_horiz', group: 'Other' }
    ]
  };

  /** 'trailer' | 'equipment' | 'truck' (anything else is a truck, as before). */
  function inspectionAssetKind(kind) {
    return kind === 'trailer' || kind === 'equipment' ? kind : 'truck';
  }

  /** The base checklist for an asset kind (a fresh copy; never the constant). */
  function inspectionBaseItems(kind) {
    var list = INSPECTION_BASE_ITEMS[inspectionAssetKind(kind)];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      out.push({ id: list[i].id, label: list[i].label, icon: list[i].icon, group: list[i].group });
    }
    return out;
  }

  /** Free-text vehicle type -> comparison key (trim + lower-case). '' for none. */
  function inspectionTypeKey(type) {
    if (type === null || type === undefined) return '';
    if (typeof type !== 'string' && typeof type !== 'number') return '';
    return String(type).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function _itText(v, max) {
    if (typeof v !== 'string') return '';
    // Control characters out (a newline in a label would break a printed row).
    var s = v.replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim();
    return s.length > max ? s.slice(0, max).trim() : s;
  }

  function _itId(v) {
    if (typeof v !== 'string') return '';
    var s = v.trim();
    if (!s || s.length > INSPECTION_TEMPLATE_LIMITS.maxIdLen) return '';
    return /^[A-Za-z0-9_-]+$/.test(s) ? s : '';
  }

  /**
   * Clean ONE template. Returns { ok, template, errors }. `ok` is false when the
   * template is unusable (no id, no name, no items, bad kind); the cleaned copy is
   * still returned so an editor can show what it kept. Never throws.
   */
  function sanitizeInspectionTemplate(raw) {
    var L = INSPECTION_TEMPLATE_LIMITS;
    var errors = [];
    var src = raw && typeof raw === 'object' ? raw : {};
    var id = _itId(src.id);
    if (!id) errors.push('missing id');
    var name = _itText(src.name, L.maxNameLen);
    if (!name) errors.push('Give the checklist a name.');
    var assetKind = INSPECTION_ASSET_KINDS.indexOf(src.assetKind) >= 0 ? src.assetKind : '';
    if (!assetKind) errors.push('Pick vehicles, trailers or equipment.');

    var vehicleTypes = [];
    var seenType = Object.create(null); // TASK-10135: a "constructor" key must not read as seen
    var rawTypes = Array.isArray(src.vehicleTypes) ? src.vehicleTypes : [];
    for (var t = 0; t < rawTypes.length && vehicleTypes.length < L.maxTypes; t++) {
      var key = inspectionTypeKey(rawTypes[t]).slice(0, L.maxNameLen);
      if (key && !seenType[key]) { seenType[key] = true; vehicleTypes.push(key); }
    }
    var unitIds = [];
    var seenUnit = Object.create(null);
    var rawUnits = Array.isArray(src.unitIds) ? src.unitIds : [];
    for (var u = 0; u < rawUnits.length && unitIds.length < L.maxUnits; u++) {
      var uid = typeof rawUnits[u] === 'string' ? rawUnits[u].trim() : '';
      if (uid && uid.length <= 128 && uid.indexOf('/') < 0 && !seenUnit[uid]) { seenUnit[uid] = true; unitIds.push(uid); }
    }

    var items = [];
    var seenItem = Object.create(null);
    var rawItems = Array.isArray(src.items) ? src.items : [];
    for (var i = 0; i < rawItems.length; i++) {
      var it = rawItems[i] && typeof rawItems[i] === 'object' ? rawItems[i] : null;
      if (!it) continue;
      var label = _itText(it.label, L.maxLabelLen);
      var iid = _itId(it.id);
      if (!label || !iid || seenItem[iid]) continue;
      if (items.length >= L.maxItems) { errors.push('A checklist can have at most ' + L.maxItems + ' items.'); break; }
      seenItem[iid] = true;
      items.push({ id: iid, label: label, required: it.required === true, photoRequired: it.photoRequired === true, phase: inspectionItemPhase(it.phase) });
    }
    if (!items.length) errors.push('Add at least one item.');

    var template = {
      id: id,
      name: name,
      assetKind: assetKind || 'truck',
      vehicleTypes: vehicleTypes,
      unitIds: unitIds,
      // TASK-10135 — missing (saved before the choice existed) = 'replace'.
      unitMode: src.unitMode === 'add' ? 'add' : 'replace',
      items: items,
      active: src.active !== false
    };
    return { ok: !!(id && name && assetKind && items.length), template: template, errors: errors };
  }

  /** The usable templates from a stored list (bad entries dropped, never thrown). */
  function normalizeInspectionTemplates(list) {
    var out = [];
    var seen = Object.create(null);
    if (!Array.isArray(list)) return out;
    for (var i = 0; i < list.length && out.length < INSPECTION_TEMPLATE_LIMITS.maxTemplates; i++) {
      var r = sanitizeInspectionTemplate(list[i]);
      if (r.ok && !seen[r.template.id]) { seen[r.template.id] = true; out.push(r.template); }
    }
    return out;
  }

  function _itLabelKey(label) {
    return String(label || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /**
   * The type checklist followed by the unit checklist's own items, an item whose
   * label matches one already listed shown once: it fails as strictly as either
   * copy (must-pass / photo if EITHER says so) and shows on both inspections
   * when the two copies name different ones. Each item keeps `tplId`, the
   * checklist it came from, so its checkbox key stays unique.
   */
  function _itMerge(typeTpl, unitTpl) {
    var items = [];
    var byLabel = Object.create(null);
    var lists = [typeTpl, unitTpl];
    for (var l = 0; l < lists.length; l++) {
      for (var i = 0; i < lists[l].items.length; i++) {
        var it = lists[l].items[i];
        var key = _itLabelKey(it.label);
        var prev = byLabel[key];
        if (prev) {
          prev.required = prev.required || it.required === true;
          prev.photoRequired = prev.photoRequired || it.photoRequired === true;
          if (prev.phase !== inspectionItemPhase(it.phase)) prev.phase = 'both';
          continue;
        }
        var copy = { id: it.id, label: it.label, required: it.required === true, photoRequired: it.photoRequired === true, phase: inspectionItemPhase(it.phase), tplId: lists[l].id };
        byLabel[key] = copy;
        items.push(copy);
      }
    }
    return {
      id: unitTpl.id,
      name: typeTpl.name + ' + ' + unitTpl.name,
      assetKind: unitTpl.assetKind,
      vehicleTypes: [],
      unitIds: [],
      unitMode: 'add',
      items: items,
      active: true,
      typeTemplateId: typeTpl.id
    };
  }

  /**
   * A copy of the template with only the items for one inspection ('pre' or
   * 'post'); any other phase value returns every item. Null when none are left.
   */
  function inspectionTemplateForPhase(template, phase) {
    if (!template || !Array.isArray(template.items)) return null;
    if (phase !== 'pre' && phase !== 'post') return template;
    var items = [];
    for (var i = 0; i < template.items.length; i++) {
      var p = inspectionItemPhase(template.items[i].phase);
      if (p === 'both' || p === phase) items.push(template.items[i]);
    }
    if (!items.length) return null;
    var out = {};
    for (var k in template) { if (Object.prototype.hasOwnProperty.call(template, k)) out[k] = template[k]; }
    out.items = items;
    return out;
  }

  /**
   * Which template (if any) applies to a unit. unit override > type > none; a
   * unit checklist set to 'add' is merged with the type's (see _itMerge).
   * @param {Array} templates  settings.inspectionTemplates (raw; normalized here)
   * @param {{assetKind:string, unitId:string, unitType:string, phase:string}} unit
   *        phase 'pre' | 'post' keeps only that inspection's items (optional)
   * @returns {{template:Object, matchedBy:string}|null}  matchedBy 'unit' | 'type' | 'unit+type'
   */
  function resolveInspectionTemplate(templates, unit) {
    var u = unit && typeof unit === 'object' ? unit : {};
    var kind = inspectionAssetKind(u.assetKind);
    var unitId = typeof u.unitId === 'string' ? u.unitId.trim() : '';
    var typeKey = inspectionTypeKey(u.unitType);
    var list = normalizeInspectionTemplates(templates);
    var i;
    var unitHit = null;
    var typeHit = null;
    if (unitId) {
      for (i = 0; i < list.length; i++) {
        if (list[i].active && list[i].assetKind === kind && list[i].unitIds.indexOf(unitId) >= 0) {
          unitHit = list[i];
          break;
        }
      }
    }
    if (typeKey && (!unitHit || unitHit.unitMode === 'add')) {
      for (i = 0; i < list.length; i++) {
        if (list[i].active && list[i].assetKind === kind && list[i].vehicleTypes.indexOf(typeKey) >= 0) {
          typeHit = list[i];
          break;
        }
      }
    }
    var hit = null;
    if (unitHit && unitHit.unitMode === 'add' && typeHit && typeHit.id !== unitHit.id) hit = { template: _itMerge(typeHit, unitHit), matchedBy: 'unit+type' };
    else if (unitHit) hit = { template: unitHit, matchedBy: 'unit' };
    else if (typeHit) hit = { template: typeHit, matchedBy: 'type' };
    if (!hit) return null;
    if (u.phase === 'pre' || u.phase === 'post') {
      var forPhase = inspectionTemplateForPhase(hit.template, u.phase);
      if (!forPhase) return null;
      hit.template = forPhase;
    }
    return hit;
  }

  /**
   * TASK-10135 — what a save would leave IGNORED, using the resolver's own
   * first-listed-wins rule. `list` is the full list as it will be stored (this
   * checklist in its final position). For every vehicle type and unit the
   * checklist names, if another ACTIVE checklist of the same kind names it too,
   * one entry: { kind: 'type'|'unit', key, winnerId, winnerName, loserId,
   * loserName }. An inactive checklist conflicts with nothing.
   */
  function inspectionTemplateConflicts(list, templateId) {
    var all = normalizeInspectionTemplates(list);
    var me = null;
    var i;
    for (i = 0; i < all.length; i++) if (all[i].id === templateId) me = all[i];
    var out = [];
    if (!me || !me.active) return out;
    var check = function (field, kind) {
      var keys = me[field];
      for (var k = 0; k < keys.length; k++) {
        var first = null;
        for (var j = 0; j < all.length; j++) {
          var t = all[j];
          if (!t.active || t.assetKind !== me.assetKind || t[field].indexOf(keys[k]) < 0) continue;
          if (!first) { first = t; continue; }
          if (first.id === me.id || t.id === me.id) {
            out.push({ kind: kind, key: keys[k], winnerId: first.id, winnerName: first.name, loserId: t.id, loserName: t.name });
          }
        }
      }
    };
    check('vehicleTypes', 'type');
    check('unitIds', 'unit');
    return out;
  }

  /** The checkbox id a template item renders under (never collides with a base id). */
  function inspectionTemplateItemKey(templateId, itemId) {
    return 'tpl__' + templateId + '__' + itemId;
  }

  /**
   * Judge the template items. `okByKey` maps inspectionTemplateItemKey -> bool
   * (true = OK, false = failed; a missing key counts as OK, the same default the
   * base checklist has). Returns the snapshot rows stored on the DVIR plus the
   * split the save path needs.
   */
  function evaluateInspectionTemplate(template, okByKey) {
    var rows = [];
    var failedRequired = [];
    var failedOptional = [];
    var photoNeeded = false;
    var items = template && Array.isArray(template.items) ? template.items : [];
    var map = okByKey && typeof okByKey === 'object' ? okByKey : {};
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      // A merged unit+type checklist keys each item by the checklist it came from.
      var key = inspectionTemplateItemKey(it.tplId || template.id, it.id);
      var ok = map[key] !== false;
      rows.push({ id: it.id, label: it.label, required: it.required === true, photoRequired: it.photoRequired === true, ok: ok });
      if (!ok) {
        if (it.required === true) failedRequired.push(it.label); else failedOptional.push(it.label);
        if (it.photoRequired === true) photoNeeded = true;
      }
    }
    return { rows: rows, failedRequired: failedRequired, failedOptional: failedOptional, photoNeeded: photoNeeded };
  }

  window.InspectionTemplates = Object.freeze({
    LIMITS: INSPECTION_TEMPLATE_LIMITS,
    ASSET_KINDS: INSPECTION_ASSET_KINDS,
    inspectionAssetKind: inspectionAssetKind,
    inspectionBaseItems: inspectionBaseItems,
    inspectionTypeKey: inspectionTypeKey,
    sanitizeInspectionTemplate: sanitizeInspectionTemplate,
    normalizeInspectionTemplates: normalizeInspectionTemplates,
    resolveInspectionTemplate: resolveInspectionTemplate,
    inspectionTemplateItemKey: inspectionTemplateItemKey,
    evaluateInspectionTemplate: evaluateInspectionTemplate,
    inspectionItemPhase: inspectionItemPhase,
    inspectionTemplateForPhase: inspectionTemplateForPhase,
    inspectionTemplateConflicts: inspectionTemplateConflicts
  });
})();
